"use client";

import Image from "next/image";
import { fontWeights } from "@/utils/fonts";

interface Feature {
  title: string;
  description: string;
}

interface ProjectSolutionProps {
  title?: string;
  statement?: string;
  features?: Feature[];
  image?: string;
}

export function ProjectSolution({
  title = "The Solution",
  statement,
  features = [],
  image
}: ProjectSolutionProps) {
  return (
    <section className="px-4 sm:px-6 bg-white">
      {/* Title Bar */}
      <div className="w-full my-4 md:my-6 lg:my-8">
        <div className="flex items-center px-3 sm:px-10 lg:px-[98px] py-1.5 sm:py-3 lg:py-4 bg-[#F1F4F7] rounded-[10px] text-[17px] sm:text-[18px] lg:text-[22px] text-[#09155E] shadow-sm max-w-[1220px] mx-auto"
          style={{ fontFamily: "Inter", fontWeight: fontWeights.inter.bold }}>
          {title}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-[1020px] mx-auto">
        <div className="space-y-4 sm:space-y-6 md:space-y-8">
          {statement && (
            <p className="text-[16px] lg:text-[20px] leading-relaxed text-[#0A165E]" style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}>
              {statement}
            </p>
          )}

          <div className="space-y-4 sm:space-y-6 md:space-y-8 mt-6 md:mt-8">
            {features.map((feat, idx) => (
              <div key={idx} className="space-y-3">
                <h3 className="text-[16px] sm:text-[18px] lg:text-[22px] text-[#0A165E]" style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.bold }}>
                  {feat.title}
                </h3>
                <p className="text-[15px] lg:text-[18px] text-[#585B6F] leading-relaxed" style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}>
                  {feat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Solution Image / Result Image */}
      {image && (
        <div className="w-full max-w-[1720px] mx-auto my-6 sm:my-8 lg:my-12">
          <div className="relative w-full rounded-[10px] sm:rounded-[15px] lg:rounded-[20px] overflow-hidden shadow-2xl">
            <Image
              src={image}
              alt={title}
              width={1720}
              height={900}
              className="w-full h-auto"
              priority
            />
          </div>
        </div>
      )}
    </section>
  );
}
